var map = {
	"./11X5.png": "53f8",
	"./ELOTT-GPI.png": "b177",
	"./ELOTT-LB.png": "9f9a",
	"./ELOTT-LOTT.png": "3ed6",
	"./ELOTT-TCG_SEA.png": "415a",
	"./ELOTT-VR.png": "ef00",
	"./ELOTT/ELOTT_1.png": "cd3b",
	"./ELOTT/ELOTT_2.png": "6b5e",
	"./ELOTT/ELOTT_3.png": "5305",
	"./ELOTT/ELOTT_4.png": "3051",
	"./ELOTT/ELOTT_5.png": "e5c0",
	"./ELOTT/ELOTT_6.png": "a2e9",
	"./GPI.png": "d68e",
	"./LAO.png": "beb2",
	"./LB.png": "7261",
	"./LF.png": "246d",
	"./LHC.png": "0fcf",
	"./LOTT-TCG_LOTTO_VN.png": "ccad",
	"./MAS.png": "ed94",
	"./PK10.png": "7d50",
	"./SSC.png": "d746",
	"./TCG_SEA.png": "ba41",
	"./THAI.png": "ce33",
	"./VNC.png": "553a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "971f";